export default {"src":"/_next/static/media/icon_girl.392993a8.svg","height":20,"width":15,"blurWidth":0,"blurHeight":0};